import React from 'react'
import { Ordering } from 'storfox-filter'

import { FILTER_NAME as name } from '../../../constants/StockAging'
import { STOCK_AGING_COLUMNS as tableColumns } from '../../../components/StockAging/StockAgingList/StockAgingTable'

export const stockAgingOrderingOptions = {
  name,
  tableColumns
}

function StockAgingOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default StockAgingOrderingForm
